import React from 'react';
import styled from 'styled-components';
import { IconSmallDropdownLegacy } from '@prezi/common-design';

type Props = {
    isOpen: boolean;
    disabled?: boolean;
};

const IconDropdown = styled(IconSmallDropdownLegacy)`
    & path {
        fill: ${({ theme }) => theme.bento.colors.text.weak};
    }

    &[data-disabled='true'] path {
        fill: ${({ theme }) => theme.bento.colors.text.main};
    }
`;

const ArrowContainer = styled.div`
    position: absolute;
    display: inline-flex;
    right: 2px;
    top: 1px;
    border-radius: ${({ theme }) => theme.bento.radius}px;
    width: 24px;
    height: 29px;
    cursor: pointer;
    align-items: center;
    color: ${({ theme }) => theme.bento.colors.text.main};
    &[data-open='true'] {
        transform: rotate(180deg);
    }
`;

export const DropdownSelectArrow = React.forwardRef<HTMLDivElement, Props>(({ isOpen, disabled, ...rest }, ref) => {
    return (
        <ArrowContainer data-open={isOpen} {...rest} ref={ref}>
            <IconDropdown data-disabled={disabled} />
        </ArrowContainer>
    );
});
